import React from "react";
import { DefaultContextValue } from "@hex-insights/core";
import { DetailViewSubPageInfos } from "./pageinfo";

export type DetailRouteContextValue = {
	subPageInfos: DetailViewSubPageInfos;
};

export const DetailRouteContext = React.createContext<DetailRouteContextValue>(
	new DefaultContextValue("DetailRouteContext") as any,
);
